import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { states } from '../../../../commonComponents/StatePicker';
import { UserProfession } from '../../../../../enums/UserProfession';
import { createAuthorizationCredential } from '../../../../../actions/licensesAction';
import { createLoadingSelector } from '../../../../../apis/selectors';

const professionOptions = [
  { code: UserProfession.RDH, name: 'Dental Hygienist' },
  { code: UserProfession.DA, name: 'Dental Assistant' },
  { code: UserProfession.EFDA, name: 'Expanded Functions DA' },
  { code: UserProfession.FD, name: 'Front Desk' },
  { code: UserProfession.DN, name: 'Associate Dentist' },
];

export const AuthorizationCredentialAdd = ({ onClose }) => {
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.users.currentUser?.id);

  const loadingSelector = createLoadingSelector(['CREATE_AUTHORIZATION']);
  const isCreating = useSelector((state) => loadingSelector(state));

  const [state, setState] = useState('');
  const [profession, setProfession] = useState('');

  const handleCreate = () => {
    if (!state || !profession) return;

    dispatch(createAuthorizationCredential(userId, { state, profession }));
    onClose();
  };

  return (
    <div style={{ padding: 10 }}>
      {/* Info card on top, full width */}
      <div className="row" style={{ marginBottom: 10 }}>
        <div
          className="col-6 offset-3"
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            overflowY: 'auto',
          }}
        >
          <div
            className="card"
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              padding: '5px 0',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: 10,
                borderBottom: '1px solid #efefef',
              }}
            >
              <div>License Status:</div>
              <div>-</div>
            </div>

            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: 10,
                borderBottom: '1px solid #efefef',
              }}
            >
              <div>State:</div>
              <select
                aria-label="State"
                className="custom-select custom-select-lg"
                value={state}
                onChange={(e) => setState(e.target.value)}
                style={{ height: 30, width: 200 }}
              >
                <option value="" disabled>
                  Select State
                </option>
                {states.map((s) => (
                  <option key={s.abbreviation} value={s.abbreviation}>
                    {s.abbreviation}
                  </option>
                ))}
              </select>
            </div>

            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: 10,
                borderBottom: '1px solid #efefef',
              }}
            >
              <div>Profession:</div>
              <select
                aria-label="Profession"
                className="custom-select custom-select-lg"
                value={profession}
                onChange={(e) => setProfession(e.target.value)}
                style={{ height: 30, width: 200 }}
              >
                <option value="" disabled>
                  Select Profession
                </option>
                {professionOptions.map((p) => (
                  <option key={p.code} value={p.code}>
                    {p.name}
                  </option>
                ))}
              </select>
            </div>

            <div
              style={{
                display: 'flex',
                marginTop: 30,
                marginBottom: 30,
                justifyContent: 'center',
                gap: 8,
              }}
            >
              <button
                className="btn btn-success"
                style={{ height: 38, width: 100 }}
                onClick={handleCreate}
                disabled={!state || !profession || isCreating}
                type="button"
              >
                {isCreating ? <Spinner animation="border" size="sm" /> : 'Add License'}
              </button>
              <button
                className="btn btn-secondary"
                style={{ height: 38, width: 100 }}
                onClick={onClose}
                type="button"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
